import axios from 'axios';

export default class AccountClient {
  constructor(url, jwt) {
    this.client = axios.create({
      baseURL: url,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      timeout: 10000,
    });
  }

  async isExtraCareInspection(folderId) {
    const uuid = await this.getCompanyUuidFromFolderId(folderId);
    return this.isCompanyExtraCareParticipant(uuid);
  }

  async getCompanyUuidFromFolderId(folderId) {
    const url = `/folders/${folderId}/company`;
    let response;
    let error;
    try {
      response = await this.client.get(url);
    } catch (err) {
      error = new Error(`\`getCompanyUuidFromFolderId\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data.companyId;
    }
    return null;
  }

  async getCompanyByUuid(companyUuid) {
    const url = `/companies/${companyUuid}`;
    let response;
    let error;
    try {
      response = await this.client.get(url);
    } catch (err) {
      error = new Error(`\`getCompanyByUuid\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data;
    }
    return null;
  }

  async isCompanyExtraCareParticipant(companyUuid) {
    const url = `/companies/${companyUuid}/settings/public/EXTRA_CARE`;
    let response;
    let error;
    try {
      response = await this.client.get(url);
    } catch (err) {
      error = new Error(`\`isCompanyExtraCareParticipant\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      if (Array.isArray(response.data.settings)) {
        return response.data.settings.some(
          setting => setting.type === 'INSURANCE_LEADS_PROGRAM_OPT_IN' && setting.value,
        );
      }
      return false;
    }
    return null;
  }

  async hasPhoneNumber() {
    const user = await this.getUser();
    const fields = ['homePhone', 'workPhone', 'mobilePhone'];
    return fields.some(field => user[field]);
  }

  async updatePhone(phoneType, phoneNumber) {
    const payload = {
      [phoneType]: phoneNumber,
    };
    let response;
    let error;
    const user = await this.getUser();
    const url = `/persons/${user.personId}`;
    try {
      response = await this.client.patch(url, payload);
    } catch (err) {
      error = new Error(`\`updatePhone\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response) {
      return response;
    }
    return null;
  }

  async updateUser(payload) {
    let response;
    let error;
    const user = await this.getUser();
    const url = `/persons/${user.personId}`;
    try {
      response = await this.client.patch(url, payload);
    } catch (err) {
      error = new Error(`\`updatePhone\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response) {
      return response;
    }
    return null;
  }

  async getUser() {
    let response;
    let error;
    try {
      response = await this.client.get('/persons/me');
    } catch (err) {
      error = new Error(`\`getUser\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response && response.data) {
      return response.data;
    }
    return null;
  }

  async getUserProfile(personId) {
    let response;
    let error;
    const url = `/persons/${personId}/profile`;
    try {
      response = await this.client.get(url);
    } catch (err) {
      error = new Error(`\`getUserProfile\` ${err}`);
    }
    if (error) {
      return Promise.reject(error);
    }
    if (response) {
      return response;
    }
    return null;
  }
}
